import { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);
const KEY = "medi_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const next = [...cur];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...cur, {
        product_id: product.id, name: product.name, price: product.price,
        image_url: product.image_url, quantity: qty,
      }];
    });
  };

  const updateQty = (product_id, quantity) => {
    if (quantity < 1) return removeItem(product_id);
    setItems((cur) => cur.map((i) => i.product_id === product_id ? { ...i, quantity } : i));
  };

  const removeItem = (product_id) => {
    setItems((cur) => cur.filter((i) => i.product_id !== product_id));
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  const value = useMemo(
    () => ({ items, addItem, updateQty, removeItem, clear, subtotal, count }),
    [items, subtotal, count]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
